import { PencilSimpleLine } from '@phosphor-icons/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { IJob } from 'jobs/types';
import { Variant } from 'theme/enums';

import { UpdateBaseInformation } from './UpdateBaseInformation';

interface IProps {
  job: IJob;
  onSubmitSuccess?: () => void;
}

export const UpdateBaseInformationButton = ({ job, onSubmitSuccess }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const handleSubmitSuccess = () => {
    onSubmitSuccess?.();
  };

  return (
    <>
      <Button
        text={t('buttonLabelEditBaseInformation')}
        startDecorator={<PencilSimpleLine />}
        variant={Variant.OUTLINED}
        onClick={() => setIsOpen(true)}
      />

      <UpdateBaseInformation
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        job={job}
        onSubmitSuccess={handleSubmitSuccess}
      />
    </>
  );
};
